<template>
  <div class="h4">
    {{ formatPrice(carDetail?.asking_price || 0) }}
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLCarDetail } from '~/types/graphql';

  const carDetail = inject<GraphQLCarDetail>('carDetail');

  const formatPrice = (price: number) => {
    return `€ ${price.toLocaleString('de-DE', {
      currency: 'EUR',
      minimumFractionDigits: 0,
    })}`;
  };
</script>

<style></style>
